import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./progress-bar.constants";
import { isValidKeyValue } from "./progress-bar.validation";
import { TKwikUIProgressBarSize } from "./progress-bar.definitions";

@Component({
  selector: "kwikui-progress-bar",
  templateUrl: "./progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"]
})
export class KwikUIProgressBarComponent implements OnInit, OnChanges {
  @Input() color: string = DEFAULT_VALUES.color;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() isShowLabel: boolean = DEFAULT_VALUES.isShowLabel;

  @Input() max: number = DEFAULT_VALUES.max;

  @Input() size: TKwikUIProgressBarSize = DEFAULT_VALUES.size;

  @Input() value: number = DEFAULT_VALUES.value;

  constructor() {}

  ngOnInit(): void {
    this.color = this.isColorEmpty() ? "var(--tui-primary)" : this.color;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    if (changes.hasOwnProperty("value") && !changes.value.firstChange) {
      this.value = changes.value.currentValue;
    }
    if (changes.hasOwnProperty("max") && !changes.max.firstChange) {
      this.max = changes.max.currentValue;
    }
    if (changes.hasOwnProperty("size") && !changes.size.firstChange) {
      this.size = changes.size.currentValue;
    }
    if (changes.hasOwnProperty("color") && !changes.color.firstChange) {
      this.color = changes.color.currentValue;
    }
    if (
      changes.hasOwnProperty("isShowLabel") &&
      !changes.isShowLabel.firstChange
    ) {
      this.isShowLabel = changes.isShowLabel.currentValue;
    }
  }

  /**
   * @description Handles setting up of error and focus on the input field is it invalid
   */
  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-progress-bar",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  isColorEmpty(): boolean {
    if (Array.isArray(this.color)) {
      if (this.color.length < 1) {
        return true;
      }
      return false;
    }
    if (this.color === "") {
      return true;
    }
    return false;
  }
}
